import { useWorkspaceAnalytics } from '@carboncopyco/utils';
import type { FormikErrors } from 'formik';
import type { WorkspaceMembersModalForm } from '../WorkspaceMembersModal';

export const useMembersModalFormAnalytics = () => {
  const {
    trackWorkspaceInsertMemberNotInOrg,
    trackWorkspaceInsertMemberInvalidEmail,
  } = useWorkspaceAnalytics('workspace_members_modal');

  return (errors: FormikErrors<WorkspaceMembersModalForm> | undefined) => {
    const getError = (error: string) => {
      if (!Array.isArray(errors?.emails) || !errors?.emails.length) {
        return;
      }
      const { length, [length - 1]: lastElement } = errors.emails;
      return lastElement.toLowerCase().includes(error);
    };

    if (getError('invalid email')) {
      return trackWorkspaceInsertMemberInvalidEmail();
    }
    if (getError('all invitees')) {
      return trackWorkspaceInsertMemberNotInOrg();
    }
    return null;
  };
};
